import { Card, Chip, Grid, Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import React from "react";
import PageLayout from "examples/LayoutContainers/PageLayout";
import dataTableData from "./components/data";
import DataTable from "./components/DataTable";
import PageTitle from "../../components/PageTitle";
import Loader from "examples/Loader";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import "../settingsCompact.css";

function Type() {
  const { data, processing, handleRefresh, main_data } = dataTableData();
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  return (
    <PageLayout>
      {processing ? (
        <Loader />
      ) : (
        <Card
          className="sd-settings"
          sx={{
            boxShadow: "0 3px 5px 0 rgba(0,0,0,.06)",
            border: "1px solid #cfd7df",
            borderRadius: "8px",
            marginRight: "1em"
          }}
        >
          <SoftBox p={3} className="sd-page__header sd-page__header--in-card">
            <PageTitle card>Location Users</PageTitle>
          </SoftBox>
          <Grid container p={5} rowSpacing={3} className="sd-page__body">
            <Grid item xs={12}>
              <DataTable table={data} canSearch />
            </Grid>
          </Grid>
        </Card>
      )}
    </PageLayout>
  );
}

export default Type;
